/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgIcon } from "../shared/SvgIcon";
var RefreshingOutlineIcon = function RefreshingOutlineIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7581 6.35332L11.2206 7.8908L12.6348 9.30501L16.6929 5.24689L12.5283 1.08228L11.1141 2.49649L12.9805 4.36286C11.0382 4.24527 8.71182 4.64418 6.82757 5.87061C4.55419 7.35032 3.04498 9.96186 3.52799 13.907L3.64952 14.8995L5.63469 14.6565L5.51317 13.6639C5.11849 10.4403 6.3155 8.59025 7.91859 7.54682C9.34688 6.61717 11.186 6.27614 12.7581 6.35332ZM12.0065 16.4609L10.469 17.9984C12.041 18.0756 13.8802 17.7346 15.3085 16.8049C16.9116 15.7615 18.1086 13.9114 17.7139 10.6878L17.5924 9.69525L19.5776 9.4522L19.6991 10.4448C20.1821 14.3899 18.6729 17.0014 16.3995 18.4811C14.5153 19.7076 12.1889 20.1065 10.2467 19.9889L12.113 21.8552L10.6988 23.2694L6.53415 19.1048L10.5923 15.0467L12.0065 16.4609Z"
  }));
};
export default RefreshingOutlineIcon;